import { Component } from 'solid-js'
import { A, useLocation } from '@solidjs/router'
import { Home, Search, Palette, MessageSquareHeart, User } from 'lucide-solid'
import { i18nStore } from '../store'

const BottomNav: Component = () => {
  const i18n = i18nStore((s) => ({ t: s.t }))
  const location = useLocation()

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/' || location.pathname === '/info'
    return location.pathname.startsWith(path)
  }

  return (
    <nav class="fixed bottom-0 left-0 right-0 z-[100] flex h-16 items-center justify-around border-t border-[var(--bg-700)] bg-[var(--bg-800)] px-2 pb-safe sm:hidden">
      <NavItem href="/" icon={<Home size={24} />} label={i18n.t.nav_home} active={isActive('/')} />
      <NavItem href="/trends" icon={<Search size={24} />} label={i18n.t.nav_trends} active={isActive('/trends')} />
      <NavItem href="/history" icon={<MessageSquareHeart size={24} />} label={i18n.t.chatHistory} active={isActive('/history')} />
      <NavItem href="/workshop" icon={<Palette size={24} />} label={i18n.t.nav_workshop} active={isActive('/workshop')} />
      <NavItem href="/profile" icon={<User size={24} />} label={i18n.t.nav_me} active={isActive('/profile')} />
    </nav>
  )
}

const NavItem: Component<{ href: string; icon: any; label: string; active: boolean }> = (props) => {
  return (
    <A
      href={props.href}
      class="flex flex-col items-center justify-center gap-1 transition-colors"
      classList={{
        'text-[var(--hl-500)]': props.active,
        'text-[var(--bg-400)]': !props.active,
      }}
    >
      {props.icon}
      <span class="text-[10px] font-medium">{props.label}</span>
    </A>
  )
}

export default BottomNav

